import { defineMessage } from 'services/localization';

export const messages = {
    optionPassword: defineMessage('password'),
    statusEnabled: defineMessage('enabled_1'),
    statusDisabled: defineMessage('not_set_2'),
    buttonSetup: defineMessage('setup'),
    buttonChange: defineMessage('change'),
    buttonCancel: defineMessage('cancel'),
    fieldOldPassword: defineMessage('old_password'),
    fieldNewPassword: defineMessage('new_password'),
    headlineSetPassword: defineMessage('set_your_password'),
    headlineChangePassword: defineMessage('change_your_password'),
    successText: defineMessage('your_password_has_been_successfully_updated'),
};
